import { baseToken } from "./common_obj";
import { baseURL } from "./common_obj";
export let base = baseURL;
console.log(base)
//设置公共的请求参数配置；
//一般get请求：
export let commonParams = {
  format: "jsonp",
  params: {
    loginToken: baseToken
  }
};
//一般post请求：
export let postCommonParams = {
  format: "jsonp",
  loginToken: baseToken
};
